import { render, staticRenderFns } from "./configItem.vue?vue&type=template&id=1a49dddc&scoped=true&"
import script from "./configItem.vue?vue&type=script&lang=js&"
export * from "./configItem.vue?vue&type=script&lang=js&"
import style0 from "./configItem.vue?vue&type=style&index=0&id=1a49dddc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a49dddc",
  null
  
)

export default component.exports